/* Stylesheet */

.select {
  margin: 0px 4px 0px 4px;
  position: relative;

  .item {
    --padding-start: 21px;
    --background: var(--ion-gradient-light);
    --background-hover: var(--ion-color-dark-primary);
    --background-hover-opacity: 0.0275;
    --ripple-color: transparent;
    border-radius: 32px;
    box-shadow: var(--ion-box-shadow);

    .value {
      color: var(--ion-color-text-primary);
    }

    .icon {
      height: 18px;
      width: 18px;
      color: var(--ion-color-text-tertiary);
    }
  }
}
